module.exports = require('react/lib/update');


/*****************
 ** WEBPACK FOOTER
 ** /usr/src/sentry/~/react-addons-update/index.js
 ** module id = 739
 ** module chunks = 1
 **/